import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
// import { Customer } from '../../types/customerTypes';
import Button from '../../components/common/Button/Button';
import styles from './EditCustomer.module.scss';

const EditCustomer: React.FC = () => {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  // const [customer, setCustomer] = useState<Customer | null>(null);
  const [loading, setLoading] = useState(true);
  // const [saving, setSaving] = useState(false);

  // Check if user has permission to edit customers
  const canEditCustomers = auth.user?.role === 'admin' || 
    auth.user?.permissions?.canManageCustomers;

  useEffect(() => {
    const loadCustomer = async () => {
      if (!id) return;
      
      setLoading(true);
      try {
        // Mock API call
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        // Mock customer data
        // const mockCustomer: Customer = {
        //   id: id,
        //   name: 'John Doe',
        //   email: 'john.doe@example.com',
        //   phone: '+1-555-0123',
        //   address: '123 Main St',
        //   city: 'New York',
        //   state: 'NY',
        //   zip_code: '10001',
        //   country: 'USA',
        //   is_active: true,
        //   created_at: '2024-01-15T10:30:00Z',
        //   updated_at: '2024-01-15T10:30:00Z',
        // };
        
        // setCustomer(mockCustomer);
      } catch (error) {
        console.error('Failed to load customer:', error);
      } finally {
        setLoading(false);
      }
    };
    
    loadCustomer();
  }, [id]);

  if (!canEditCustomers) {
    return (
      <div className={styles.errorContainer}>
        <h2>Access Denied</h2>
        <p>You don't have permission to edit customers.</p>
        <Button onClick={() => navigate('/customers')}>
          Back to Customers
        </Button>
      </div>
    );
  }

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.loadingSpinner}></div>
        <p>Loading customer...</p>
      </div>
    );
  }

  // if (!customer) {
  //   return (
  //     <div className={styles.errorContainer}>
  //       <h2>Customer Not Found</h2>
  //       <p>The customer you're looking for doesn't exist.</p>
  //       <Button onClick={() => navigate('/customers')}>
  //         Back to Customers
  //       </Button>
  //     </div>
  //   );
  // }

  // const handleSubmit = async (customerData: Partial<Customer>) => {
  //   // setSaving(true);
  //   try {
  //     // Mock API call
  //     await new Promise(resolve => setTimeout(resolve, 1000));
      
  //     // In a real app, this would call the API
  //     // await customerService.updateCustomer(id!, customerData);
      
  //     console.log('Customer updated:', customerData);
      
  //     // Navigate back to customer list
  //     navigate('/customers');
  //   } catch (error) {
  //     console.error('Failed to update customer:', error);
  //     throw error;
  //   } finally {
  //     setSaving(false);
  //   }
  // };

  return (
    <div className={styles.editCustomer}>
      {/* <CustomerForm
        customer={customer}
        onSubmit={handleSubmit}
        loading={saving}
        mode="edit"
      /> */}
    </div>
  );
};

export default EditCustomer; 